module.exports = __webpack_public_path__ + "img/leave.244c1fa6.png";